import { REACT_APP_URL } from './env';

export const URL = REACT_APP_URL;

export const LOGIN_URL = '/rest-auth/login/';
export const BASE_ROUTE_URL = '/api/base_route/';
export const BASE_ROUTE_COURSE_URL = '/api/base_route_course/';
export const TASK_ROUTE_URL = '/api/task_route/';
export const TASK_ROUTE_COURSE_URL = '/api/task_route_course/';
export const TASK_REPORT_URL = '/api/task_report/';
export const REPORT_TYPE_URL = '/api/report_type/';
export const TASK_AMOUNT_URL = '/api/task_amount/';
export const TASK_AMOUNT_ITEM_URL = '/api/task_amount_item/';
export const TASK_COLLECTION_URL = '/api/task_collection/';
export const COLLECTION_POINT_URL = '/api/collection_point/';
export const TASK_COLLECTION_POINT_URL = '/api/task_collection_point/';
export const CUSTOMER_URL = '/api/customer/';
export const GARBAGE_URL = '/api/garbage/';
export const VEHICLE_URL = '/api/vehicle/';
export const SEARCH_LOCATION_URL = '/api/search_location';
export const NOTIFICATION_URL = '/api/notification/';
export const HISTORY_URL = '/api/base_route_history/';
export const COMPANY_URL = '/api/company/';
export const MEMBER_URL = '/api/member/';
export const ROUTE_COMPANY_CUSTOMER = '/api/route_customer/';
export const ROUTE_COMPANY_GARBAGE = '/api/route_garbage/';
export const ROUTE_COMPANY_REPORT = '/api/route_report_type/';
export const ROUTE_EXPORT_CSV = '/api/export_report';
